import { defineNuxtPlugin, useNuxtApp } from '#app';
import { nextTick } from 'vue';

import type { Router } from 'vue-router';

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp();

  const router = nuxtApp.$router as Router;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  router.afterEach((to: any) => {
    // ページのフルパスを取得 例：/about#section?param=1#hash
    const fullPath = to.fullPath;
    // クエリパラメータを除去したパスを取得 例：/about#section
    const pathWithoutQuery = fullPath.split('?')[0];

    // ハッシュ部分の取得 例：#section
    const hashIndex = pathWithoutQuery.indexOf('#');
    if (hashIndex !== -1) {
      const hash = pathWithoutQuery.substring(hashIndex); // ハッシュ部分のみ取得
      // DOMが完全にロードされるのを待つ
      nextTick(() => {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          } else {
            console.warn(`Element with id ${hash} not found`);
          }
        }, 500);
      });
    }
  });
});
